<template>
	<div class="report_row report_rom_change_data_table page">
		<div class="sub_header page">
			{{ calculateTitle }}
			<span>
				{{ searchDateProps }}
			</span>
		</div>
		<div class="list">
			<ul>
				<li>{{ $t( 'status.date' ) }}</li>
				<li>{{ $t( 'unit.aRom.name' ) }}</li>
				<li>{{ $t( 'unit.pRom.name' ) }}</li>
				<li>{{ $t( 'report.components.rom_statistic.total_amount_of_exercise_per_day_as_min' ) }} </li>
				<li>Remarks</li>
			</ul>
			<ul class="page" v-for="( {date, dataOfArom, dataOfProm, amountOfExercise}, idx ) in calculateRawDataList"
				:key="idx">
				<li>{{ date }}</li>
				<li>{{ dataOfArom }}</li>
				<li>{{ dataOfProm }}</li>
				<li>{{ amountOfExercise }}</li>
				<li></li>
			</ul>
		</div>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import { DIRECTION_TRANS, POSITION_TRANS } from "@/enum/lib";

export default {
  name: 'RomChangeTable',
  props: ['searchDateProps'],
  data() {
    return {
      romChartData: {
        chartData: {},
        requestData: {}
      },
    }
  },
  methods: {
    ...mapGetters(['getReportRomChartData']),
    calculateRomChartDataFromVuex(data) {
      // vuex로부터 가지고온 값을 안전하게 vue.set 하여 저장합니다.
      // 해당 값의 변화를 감지합니다. 물론 현재 상태에서는 변화를 감지할 포인트는 없습니다만.
      this.$set(this.romChartData, 'chartData', data?.chartData ?? {});
      this.$set(this.romChartData, 'requestData', data?.requestData ?? {});
    },
    rawItemColumnCreator(item) {
      return {
        date: item?.date ?? undefined,
        dataOfArom: item?.dataOfArom ?? 0 + this.$t('unit.deg'),
        dataOfProm: item?.dataOfProm ?? 0 + this.$t('unit.deg'),
        amountOfExercise: item?.amountOfExercise ?? 0
      }
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe((_mutation, state) => {
      this.calculateRomChartDataFromVuex(state.report.romChartData);
    });
  },
  mounted() {
    this.calculateRomChartDataFromVuex(this.getReportRomChartData());
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  computed: {
    calculateRawDataList() {
      const data = [];
      for (let i = 0; i < this.romChartData.chartData?.date?.length ?? 0; i++) {
        data.push(this.rawItemColumnCreator({
          date: this.romChartData.chartData.date[i],
          dataOfArom: this.romChartData.chartData.dataOfArom[i],
          dataOfProm: this.romChartData.chartData.dataOfProm[i],
          amountOfExercise: this.romChartData.chartData.amountOfExercise[i]
        }));
      }
      return data;
    },
    calculateTitle() {
      return this.$t('report.paper.rehabilitation.raw_data',
          {
            position: this.$t(POSITION_TRANS[this.romChartData?.requestData?.position ?? 0].trans),
            direction: this.$t(DIRECTION_TRANS[this.romChartData?.requestData?.direction ?? 0].trans)
          });
    },
    calculateSearchRange() {
      return `(${this.moment(this.romChartData.requestData.startDatetime).locale(this.$t('country')).format('ll')}
             ~ ${this.moment(this.romChartData.requestData.endDatetime).locale(this.$t('country')).format('ll')})`;
    }
  }
}
</script>
<style lang="scss" scoped>

</style>